import { render, staticRenderFns } from "./CompanySubscribersDeleteDialog.vue?vue&type=template&id=299ae1f6&scoped=true"
import script from "./CompanySubscribersDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./CompanySubscribersDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./CompanySubscribersDeleteDialog.vue?vue&type=style&index=0&id=299ae1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299ae1f6",
  null
  
)

export default component.exports